import axios from 'axios';
import qs from 'qs';

const stripeAPI = axios.create({
  baseURL: 'https://api.stripe.com/v1/',
});

stripeAPI.interceptors.request.use((request) => {
  request.headers.Authorization = `Bearer ${process.env.STRIPE_PRIVATE_KEY}`;
  return request;
}, error => Promise.reject(error));

stripeAPI.interceptors.response.use(response => response, (error) => {
  if (error && error.response) {
    return Promise.reject(error.response.data);
  } else {
    return Promise.reject(error);
  }
});

const getBankAccounts = ({ customerId }) => stripeAPI.get(`customers/${customerId}/sources`, { params: { object: 'bank_account' } });
const getCreditCards = ({ customerId }) => stripeAPI.get(`customers/${customerId}/sources`, { params: { object: 'card' } });
const createSource = ({ customerId, body }) => stripeAPI.post(`customers/${customerId}/sources`, qs.stringify(body));
const deleteSource = ({ customerId, accountId }) => stripeAPI.delete(`customers/${customerId}/sources/${accountId}`);
const getCustomer = ({ customerId }) => stripeAPI.get(`customers/${customerId}`);
const updateCustomer = ({ customerId, body }) => stripeAPI.post(`customers/${customerId}`, qs.stringify(body));

export default {
  getBankAccounts,
  createSource,
  deleteSource,
  getCreditCards,
  getCustomer,
  updateCustomer,
};



// WEBPACK FOOTER //
// ./src/api/stripe.js